exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-cc0f5e1c] .el-form-item{margin-bottom:14px}[data-v-cc0f5e1c] .el-table th{background-color:#f7fbff}[data-v-cc0f5e1c] .from-s .flex-row .el-form-item{margin-right:10px;margin-left:0}\n", ""]);

// exports
